import React from 'react';
import { Alert, Card, Link, Modal, PillButton, Row, Stack, Text, Title } from 'library/ui';
import { useUserContext } from 'UserContext';

export function ReferralModal({ isOpen, onClose, small }: { isOpen: boolean; onClose: () => void; small?: boolean }) {
    const { user } = useUserContext();

    const refCode = user?.referral_code || user?.businesses_active?.[0]?.user?.referral_code;
    const referralLink = `${window.location.origin}?referral=${refCode}`;

    if (!isOpen) return null;

    return (
        <Modal onClose={onClose} width={small ? undefined : 520}>
            <Stack padding="sm">
                <Title size="h1" tone="accent">
                    Refer a Center
                </Title>
                <Card tone="muted">
                    <Stack gap="sm">
                        <Text weight="bold">How does it work?</Text>
                        <ul>
                            <li>
                                <Text size="sm">
                                    Share your custom sign up link with a center that may be interested in using Tandem
                                    to find staff.
                                </Text>
                            </li>
                            <li>
                                <Text size="sm">
                                    Your referral signs up and posts their first job on the Tandem site.
                                </Text>
                            </li>
                            <li>
                                <Text size="sm">
                                    Once your referral posts a job and uses their first worker,{' '}
                                    <b>you will both get $50 added to your Tandem account.</b>
                                </Text>
                            </li>
                        </ul>
                    </Stack>
                </Card>
                <Alert variant="info">
                    <Stack gap="sm">
                        <Text weight="bold">Ready to refer a center?</Text>
                        <Text size="sm">Share your custom referral code:</Text>
                        <Row justify="center">
                            <Title size="h2">{refCode}</Title>
                        </Row>
                        <Row>
                            <Text size="sm">
                                or{' '}
                                <Link onClick={() => navigator.clipboard.writeText(referralLink)}>
                                    click here to copy your referral link!
                                </Link>
                            </Text>
                        </Row>
                    </Stack>
                </Alert>
                <Row justify="end">
                    <PillButton onClick={onClose}>Close</PillButton>
                </Row>
            </Stack>
        </Modal>
    );
}
